import type { ReactNode } from "react";

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
};

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-6 md:mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-label font-bold tracking-[0.2em] text-primary-600 uppercase mb-3">
            <span className="w-6 h-px bg-primary-500" aria-hidden="true" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm md:text-[15px] leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}